export const TIPO_DESC_ACRE = {
  VALOR: 1,
  PERCENTUAL: 2,
};
